import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D80027\" d=\"M1.457 6.262h21.082A12 12 0 0 0 11.998 0c-4.549 0-8.506 2.53-10.541 6.26M11.998 24c4.549 0 8.506-2.53 10.54-6.26H1.458A12 12 0 0 0 11.998 24\"></path><path fill=\"#FFDA44\" d=\"M16.176 12c0 2.305-1.869 3.652-4.174 3.652S7.828 14.305 7.828 12a4.174 4.174 0 1 1 8.348 0\"></path><path fill=\"#0052B4\" d=\"M16.176 12a4.174 4.174 0 1 1-8.348 0\"></path><path fill=\"#D80027\" d=\"M10.434 10.956H9.391v2.087h1.043zM14.606 10.956h-1.043v2.087h1.043zM12.52 9.391h-1.043v3.652h1.043z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }